import sharedMutations from "@/store/utils/shared-mutations";

const REMOVE_PLAYER_FROM_ROSTER = (state, id) => {
  const player = state.rosterList.find(player => player["id"] === id);
  state.rosterList.splice(state.rosterList.indexOf(player), 1);
};

const CLEAR_LIMITED_ROSTER = state => {
  state.rosterListLimited = []
}

export default {
  ...sharedMutations,
  REMOVE_PLAYER_FROM_ROSTER,
  CLEAR_LIMITED_ROSTER
};
